import {iniciarRequisicao, logout} from "@/helpers";
import api from "@/api/api";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarDetalhamentoSugestaoCompra = async (params) => {
  const config = {params, headers: iniciarRequisicao()};
  const {data, status} = await api.get('produtos/sugestao-compra/detalhamento', config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.detalhamento;
  }

  logout();
}

export const buscarDetalhamentoProduto = async (params) => {
  const config = {params, headers: iniciarRequisicao()};
  const {data, status} = await api.get('produtos/sugestao-compra/detalhamento-produto', config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.detalhamento;
  }

  logout();
}
